import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ExampleComponent } from './example.component';
import {NzButtonModule} from 'ng-zorro-antd/button';
import {ExampleRoutingModule} from './example-routing.module';
import {NzGridModule} from 'ng-zorro-antd/grid';
import {NzCheckboxModule} from 'ng-zorro-antd/checkbox';
import {FormsModule} from '@angular/forms';
import {NzRadioModule} from 'ng-zorro-antd/radio';
import {NzSwitchModule} from 'ng-zorro-antd/switch';
import {NzTabsModule} from 'ng-zorro-antd/tabs';
import {NzInputModule} from 'ng-zorro-antd/input';
import {NzIconModule} from 'ng-zorro-antd/icon';
import {NzDatePickerModule} from 'ng-zorro-antd/date-picker';
import {NzSpinModule} from 'ng-zorro-antd/spin';
import {NzSelectModule} from 'ng-zorro-antd/select';



@NgModule({
  declarations: [
    ExampleComponent
  ],
  imports: [
    CommonModule,
    NzButtonModule,
    ExampleRoutingModule,
    NzGridModule,
    NzCheckboxModule,
    FormsModule,
    NzRadioModule,
    NzSwitchModule,
    NzTabsModule,
    NzInputModule,
    NzIconModule,
    NzDatePickerModule,
    NzSpinModule,
    NzSelectModule
  ]
})
export class ExampleModule { }
